import * as React from "react";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementStatic
} from "@bizform/type/model/component_element/ComponentElement.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {DomAttribute} from "@bizform/type/model/dom/DomAttribute.model";
import {
    GridIdKeyConstant,
    GridLinkIdKeyConstant
} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {ComponentHelper, Debug, StringHelper} from "@bizform/helper/dist/js/bizflow/helper.min";
import {
    ComponentElementClass,
    GridDataService,
    ReactComponentElementInit
} from "@bizform/core/dist/js/bizflow/core.min";
import {AbstractComponentElement} from "../bf_component/AbstractComponentElement";
import {GridHelper} from "./helper/Grid.helper";


type Props =  {
};

type State = BaseStateModel & {
    [GridIdKeyConstant]?: string;
    containerClassName?: string;
    containerStyle?: object;
};

/**
 * Grid Action Container
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfGridActionContainer extends AbstractComponentElement<Props, State> {
    static readonly pluginType: string = PluginType.GRIDHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_o4py3TpkEco1957h_og5vR6lpFXKG2B",
        category: ComponentCategory.HANDLER,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "Search/Retrieve Action Container",
        description: "Search/Retrieve Action Container",
        icon: "",
        property: null
    };

    setProperty(property: ComponentElementProperty) {
        try {
            const newState: any = ComponentHelper.createStateWithProperties<State, null>(
                property,
                this);
            this.setState(newState);
            GridDataService.setConfigSearch(StringHelper.elementId(this.elementId), newState.search);
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfGridActionContainer)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    constructor(props?: Props) {
        super(props);
        this.state = {};
        this._setRef = this._setRef.bind(this);
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if (!this.displayMode || !this.state[GridIdKeyConstant]) {
            return null;
        } else {
            return (
                <React.Fragment>
                    {GridHelper.infoGridContainer(this.parentDom, this.state[GridIdKeyConstant], "Search/Retrieve Action Container", this.elementId, this.state[GridLinkIdKeyConstant], null, "Action")}
                    {this._container()}
                </React.Fragment>
            );
        }
    }

    private _container() {
        const attr = {
            [DomAttribute.GRIDID]: this.state[GridIdKeyConstant],
            [DomAttribute.GRIDLINKID]: this.state[GridLinkIdKeyConstant],
            [DomAttribute.CONTAINER]: "",
            [DomAttribute.GRIDSEARCHCONTAINER]: StringHelper.elementId(this.elementId)
        };
        const className = "m-0 p-0 w-100" + (this.state.containerClassName ? " " + this.state.containerClassName : "");
        return (
            <div ref={this._setRef} className={className} style={this.state.containerStyle}
                { ...attr }
            ></div>
        );
    }

    private _setRef(ref) {
        if (ref) {
            this.readyComponent();
        }
    }
}
